import {type RefObject, useEffect, useRef} from 'react';

import uwmMessageService from '@/services/uwm/uwmMessageService';

const useScrollMessages = (scrollRef: RefObject<HTMLElement | null>) => {
    const lastScrollTopRef = useRef(0);

    useEffect(() => {
        const element = scrollRef.current;
        if (!element) return;

        lastScrollTopRef.current = element.scrollTop;

        const handleScroll = () => {
            const scrollTop = element.scrollTop;
            const delta = scrollTop - lastScrollTopRef.current;
            lastScrollTopRef.current = scrollTop;

            if (delta !== 0) {
                uwmMessageService.sendScrollMessage(delta, scrollTop);
            }
        };

        element.addEventListener('scroll', handleScroll, {passive: true});
        return () => element.removeEventListener('scroll', handleScroll);
    }, [scrollRef]);
};

export default useScrollMessages;
